module.exports = __webpack_public_path__ + "img/1.c0f4e476.jpg";